import { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const CHANNELS = [["email", "Email"], ["whatsapp", "WhatsApp"], ["sms", "SMS"]];

/** Which events alert this user, and through which channels. */
export const NotificationPrefs = () => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/me/notification-prefs").then(({ data }) => setP(data)).catch(() => {}); }, []);
  const save = async (next) => {
    setP(next);
    try { const { data } = await api.put("/me/notification-prefs", { events: next.events, channels: next.channels }); setP(data); toast.success("Preferences saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!p) return null;
  const Toggle = ({ on, onChange, testId }) => (
    <button type="button" role="switch" aria-checked={on} onClick={() => onChange(!on)} data-testid={testId}
      className={`relative h-5 w-9 rounded-full transition-colors duration-200 ${on ? "bg-blue-900" : "bg-slate-300 dark:bg-slate-700"}`}>
      <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-transform duration-200 ${on ? "translate-x-4" : "translate-x-0.5"}`} />
    </button>
  );
  return (
    <section className="border border-border bg-card p-7" data-testid="notification-prefs">
      <p className="flex items-center gap-2 label-caps"><BellRing className="h-3.5 w-3.5" /> Notification preferences</p>
      <p className="text-sm text-muted-foreground mt-3">In-app alerts are always kept. Choose which events also reach you and by which channel.</p>
      <div className="mt-5 grid grid-cols-3 gap-3">
        {CHANNELS.map(([k, l]) => (
          <label key={k} className="border border-border p-3 flex items-center justify-between text-sm" data-testid={`channel-${k}`}>
            {l}<Toggle on={p.channels[k]} onChange={(v) => save({ ...p, channels: { ...p.channels, [k]: v } })} testId={`channel-toggle-${k}`} />
          </label>
        ))}
      </div>
      <ul className="mt-5 divide-y divide-border">
        {Object.entries(p.catalogue).map(([k, label]) => (
          <li key={k} className="py-2.5 flex items-center justify-between text-sm" data-testid={`event-${k}`}>
            {label}<Toggle on={p.events[k]} onChange={(v) => save({ ...p, events: { ...p.events, [k]: v } })} testId={`event-toggle-${k}`} />
          </li>
        ))}
      </ul>
    </section>
  );
};
